var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlocateItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.284,
    height: 20.291,
    viewBox: "0 0 25.284 20.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.611 -4478.982)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.211,4481.735a1.354,1.354,0,0,1,1.352-1.352h4.257v-1.4h-4.257a2.756,2.756,0,0,0-2.752,2.753v4.257h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.211,4496.52v-4.257h-1.4v4.257a2.756,2.756,0,0,0,2.752,2.753h4.257v-1.4h-4.257A1.354,1.354,0,0,1-370.211,4496.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-347.028,4488.724h-7.029l1.988-1.988a.7.7,0,0,0,.2-.495.7.7,0,0,0-.2-.5.7.7,0,0,0-.989.008h0l-3.167,3.167a.7.7,0,0,0-.2.512.689.689,0,0,0,.2.512l3.167,3.167a.7.7,0,0,0,.99,0h0a.7.7,0,0,0,.2-.5.7.7,0,0,0-.2-.5l-1.988-1.989h7.029a.7.7,0,0,0,.7-.7A.7.7,0,0,0-347.028,4488.724Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.973,
    height: 6.973,
    rx: 1.12,
    transform: "translate(-365.264 4485.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.551,4481.735v2.085h1.4v-2.085a2.756,2.756,0,0,0-2.752-2.753h-4.257v1.4h4.257A1.354,1.354,0,0,1-353.551,4481.735Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.551,4496.52a1.354,1.354,0,0,1-1.352,1.352h-4.257v1.4h4.257a2.756,2.756,0,0,0,2.752-2.753v-2.087h-1.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlocateItem);
export default __webpack_public_path__ + "static/media/alocateItem.225224ab3451111bad96e7f8b23c557a.svg";
export { ForwardRef as ReactComponent };